import mvtRange from '@/common/components/mvtrange/mvt-range.vue';
import mvtRangeSlider from '@/common/components/mvtrangeslider/mvt-rangeslider.vue';
import mvtInputCurrency from '@/common/components/mvtinputcurrency/mvt-inputcurrency.vue';
import mvtInputSqft from '@/common/components/mvtinputsqft/mvt-inputsqft.vue';
import mvtInputNumber from '@/common/components/mvtinputnumber/mvt-inputnumber.vue';
import mvtInputInt from '@/common/components/mvtinputint/mvt-inputint.vue';
import mvtCheckbox from '@/common/components/mvtcheckbox/mvt-checkbox.vue';

export default {
    name: 'mvtInputRange',
    emits: ['update:modelValue'],
    components: {
        mvtRange,
        mvtRangeSlider,
        mvtInputCurrency,
        mvtInputNumber,
        mvtInputSqft,
        mvtInputInt,
        mvtCheckbox,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: Object,
            default: {},
            required: false,
        },
        theme: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Object,
            default: () => ({
                trigger: 'input',
                mapping: {
                    min: 'min',
                    max: 'max',
                },
                input: 'number',
                defaultValue: [0, 0],
                placeholderMin: 'No Min',
                placeholderMax: 'No Max',
                readonly: false,
                extraData: null,
            }),
        },
    },

    mounted() {
        this.$refs.min.$el.addEventListener('focus', () => {
            this.$refs.min.$el.focus();
        });
        this.$refs.max.$el.addEventListener('focus', () => {
            this.$refs.max.$el.focus();
        });
    },
    methods: {
        changeValue(value) {
            let newItem = {};
            newItem[this.rangeSliderOptions.mapping.min] = value[0];
            newItem[this.rangeSliderOptions.mapping.max] = value[1];
            this._value = newItem;
        },
        changeMin(value) {
            let newItem = {};
            newItem[this.rangeSliderOptions.mapping.min] = value;
            newItem[this.rangeSliderOptions.mapping.max] = this._value[this.rangeSliderOptions.mapping.max];
            this._value = newItem;
        },
        changeMax(value) {
            let newItem = {};
            newItem[this.rangeSliderOptions.mapping.min] = this._value[this.rangeSliderOptions.mapping.min];
            newItem[this.rangeSliderOptions.mapping.max] = value;
            this._value = newItem;
        },
        checkMax() {
            let min = this._value[this.rangeSliderOptions.mapping.min];
            let max = this._value[this.rangeSliderOptions.mapping.max];
            if (min > 0 && max > 0 && min > max) {
                this.changeMax(this.rangeSliderOptions.defaultValue[1]);
            }
        },
        checkMin() {
            let min = this._value[this.rangeSliderOptions.mapping.min];
            let max = this._value[this.rangeSliderOptions.mapping.max];
            if (min > 0 && max > 0 && min > max) {
                this.changeMin(this.rangeSliderOptions.defaultValue[0]);
            }
        },
    },

    computed: {
        extraData: {
            get() {
                if (this.options.extraData) {
                    return [this.options.extraData];
                }
                return [];
            },
        },
        extralValue: {
            get() {
                if (this.extraData && this.extraData.length === 1) {
                    if (this.extraData[0].value[0] === this.minValue && this.extraData[0].value[1] === this.maxValue) {
                        return this.extraData[0].value;
                    }
                }
                return this.rangeSliderOptions.defaultValue;
            },
            set(value) {
                if (!value) {
                    value = this.rangeSliderOptions.defaultValue;
                }
                this.changeValue(value);
            },
        },
        rangeSliderData() {
            if (this.data && this.data.length > 0) {
                return this.data;
            }
            return [];
        },
        rangeSliderOptions() {
            return this.options;
        },
        minChanged() {
            let min = this._value[this.rangeSliderOptions.mapping.min];
            if (this.rangeSliderOptions.defaultValue && this.rangeSliderOptions.defaultValue.length === 2) {
                //check if this.rangeSliderOptions.defaultValue[0] is not number
                if (/\d+/.test(this.rangeSliderOptions.defaultValue[0])) {
                    return min > this.rangeSliderOptions.defaultValue[0];
                } else {
                    return min > 0;
                }
            }
            return !min;
        },
        maxChanged() {
            let max = this._value[this.rangeSliderOptions.mapping.max];
            if (this.rangeSliderOptions.defaultValue && this.rangeSliderOptions.defaultValue.length === 2) {
                if (/\d+/.test(this.rangeSliderOptions.defaultValue[1])) {
                    return max > this.rangeSliderOptions.defaultValue[1];
                } else {
                    return max > 0;
                }
            }
            return !max;
        },
        changed() {
            return this.minChanged || this.maxChanged;
        },
        maxValue: {
            get() {
                return this._value[this.rangeSliderOptions.mapping.max] * 1;
            },
            set(value) {
                this.changeMax(value);
            },
        },
        minValue: {
            get() {
                return this._value[this.rangeSliderOptions.mapping.min] * 1;
            },
            set(value) {
                this.changeMin(value);
            },
        },
        rangeValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        _value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    beforeUnmount() {
        $(this.$refs.min.$el).off('focus');
        $(this.$refs.max.$el).off('focus');
    },
};
